// Store contact surfaces used by the shop UI. One place for the WhatsApp line
// so a number change happens once. Pure and client-safe.

/** Store WhatsApp line in wa.me form (E.164 digits, no plus). Confirmed 2026-10-08. */
export const STORE_WHATSAPP = "19784098158";
export const STORE_WHATSAPP_DISPLAY = "+1 (978) 409-8158";
export const STORE_ADDRESS = "192 Broadway, Lawrence, MA 01840";

function waUrl(text: string): string {
  return `https://wa.me/${STORE_WHATSAPP}?text=${encodeURIComponent(text)}`;
}

/**
 * "Ask about it" for one product. The message is in Spanish because that is
 * the language the store answers in; the product name and URL travel with it
 * so staff know exactly which piece the shopper means.
 */
export function whatsappAskUrl(productName: string, productUrl: string): string {
  return waUrl(
    `Hola, me interesa este producto de Muñeca's Couture:\n${productName}\n${productUrl}\n¿Está disponible?`,
  );
}

/** Brand-level ask (the sold-out band and the empty state on a brand page). */
export function whatsappBrandUrl(brandLabel: string, brandUrl: string): string {
  return waUrl(`Hola, quiero preguntar por las piezas de ${brandLabel} en Muñeca's Couture:\n${brandUrl}`);
}
